import _ from "underscore";

import SocialCredential from "./base";

var FacebookCredential = SocialCredential.extend({
    parse: function (response) {
        response = FacebookCredential.__super__.parse.apply(this, arguments);

        if (_.isString(response.facebookPageName)) {
            response.name = response.facebookPageName;
            response.profileImage = response.facebookPageProfileImageUrl;
        } else {
            response.name = response.facebookName;
            response.profileImage = response.facebookProfileImageUrl;
        }

        response.type = `facebook`;
        response.credentialType = `facebook_page`;
        response.typeLabel = `Facebook`;
        response.platformType = `Facebook Page`;

        return response;
    },

    isSocialMedia: function () {
        return true;
    },

    share: function (shareId, data) {
        data = _.extend(data, this.getFacebookCrosspostingPages());
        return FacebookCredential.__super__.share.call(this, shareId, data);
    },

    getFacebookCrosspostingPages: function () {
        return {
            facebookCrosspostPageIds: this.get(`facebookCrosspostPageIds`)
        };
    },

    onShareSuccessful: function (response) {
        return FacebookCredential.__super__.onShareSuccessful.call(
            this,
            `shareViaFacebookCount`,
            response
        );
    }
});

export default FacebookCredential;
